export default __webpack_public_path__ + "static/media/arivaone.2ae92cc4.jpg";